<clinic-layout [title]="'Review Consultation'" [reviewPage]="true">
    <app-progress-bar *ngIf="!!orderItem" [stepPosition]="8" [orderId]="orderId" [patientEmail]="patient?.email" [isFormIncomplete]="brief.isIncomplete">
        <patient-details *ngIf="!!patient" [patient]="patient"></patient-details>
        <app-questionnaire-brief #brief [orderId]="orderId" [notes]="gpNote" [orderItem]="orderItem"></app-questionnaire-brief>
    </app-progress-bar>
</clinic-layout>